import { render } from "./CollectionsResultsTableTab.vue?vue&type=template&id=a2d476c4&scoped=true"
import script from "./CollectionsResultsTableTab.vue?vue&type=script&lang=js"
export * from "./CollectionsResultsTableTab.vue?vue&type=script&lang=js"

import "./CollectionsResultsTableTab.vue?vue&type=style&index=0&id=a2d476c4&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2d476c4"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QField});
